import { Injectable, OnDestroy } from '@angular/core';
import { ChatbotService } from './chatbot.service';
import { Subscription } from 'rxjs';

/**
 * A simple service to control a popup component (e.g., chatbot).
 * It stores a reference to the component and allows minimizing it from anywhere in the app (ex: from eBook).
 */
@Injectable({
  providedIn: 'root'
})
export class ChatbotPopupService implements OnDestroy {
  private popupComponentRef: any;

  private _sessionQuotaEventSub: Subscription = new Subscription();
  private _promptQuotaEventSub: Subscription = new Subscription();

  public isOutOfPrompts: boolean = false;
  public isOutOfSessions: boolean = false;

  constructor(private _chatbotService: ChatbotService) {
    this._sessionQuotaEventSub = this._chatbotService.sessionsQuota$.subscribe((status) => {
        this.isOutOfSessions = status.limitReached;
    });

    this._promptQuotaEventSub = this._chatbotService.promptQuota$.subscribe((p) => {
        this.isOutOfPrompts = p.limitReached;
    });
  }

  public registerPopupComponent(ref: any): void {
    this.popupComponentRef = ref;
  }

  public minimizePopup(): void {
    if (this.popupComponentRef) {
      this.popupComponentRef.onMinimizeChatbotPopup();
    }
  }

  public openPopup(text: string): void {
    if (this.isOutOfPrompts && this.isOutOfSessions) {
      return;
    }

    if (this.popupComponentRef) {
      this.popupComponentRef.onOpenChatbotPopup(text);
    }
  }

  ngOnDestroy(): void {
    this._sessionQuotaEventSub.unsubscribe();
    this._promptQuotaEventSub.unsubscribe();
  }
}
